export const getFullName = (strs: (string | undefined | null)[]): string => {
  return strs.filter((str): str is string => !!str).join(' ') || ''
}
